/**
 * Conformant blank-document DXF skeleton (AutoCAD R2018 / AC1032).
 *
 * GENERATED, DO NOT HAND-EDIT. Produced by `ezdxf.new("R2018")` with an EMPTY
 * modelspace (no entities) and serialized verbatim (CRLF normalized to LF; the
 * streaming parser strips carriage returns). R2018/AC1032 matches the
 * `100/AcDb*` subclass markers the typed dxf-io writer emits, so the captured
 * structural tables (VPORT/LTYPE/LAYER/STYLE/VIEW/UCS/APPID/DIMSTYLE/
 * BLOCK_RECORD), the BLOCKS section (`*Model_Space`/`*Paper_Space`), the CLASSES
 * section, the HEADER (with `$ACADVER = AC1032` / `$ACADMAINTVER = 4` /
 * `$HANDSEED`) and the OBJECTS root DICTIONARY all round-trip through
 * `importDxfStringToDrawingDocument` → the carry-forward writer cleanly
 * (validated by an ezdxf strict round-trip). R2018 is the ТЗ format target
 * (SL-17, product decision); imported documents keep their own carried-forward
 * `$ACADVER` — only FROM-SCRATCH saves adopt this R2018 skeleton.
 *
 * Because `$ACADVER = AC1032` is R2007+, the writer's version-derived
 * `escapeUnicode` default (dxf-io `shouldEscapeForVersion`) resolves to raw
 * UTF-8 (no `\\U+XXXX` escaping) for from-scratch saves — the native R2018 text
 * encoding — without any explicit selector.
 *
 * Consumed by `ensureConformantSkeleton` (dxfBridge.conformantSkeleton.ts) to
 * back-fill the conformant DXF structure onto FROM-SCRATCH documents (File →
 * New, no raw DXF source) so their export is AutoCAD/ezdxf-readable. The
 * skeleton's own handles occupy a low range (≤ ~0x100); entity handles are
 * re-minted from a high base (0x100000+) to avoid collision.
 *
 * The ~18 KB DXF text is stored as two data parts
 * (`dxfBridge.conformantSkeleton.part0/part1.ts`) only so each data file stays
 * under the 2000-line source-file ceiling; they are concatenated here with a
 * single newline (the exact split boundary) to reproduce the original DXF
 * byte-for-byte.
 *
 * Source of truth: Autodesk DXF R2018 reference + ezdxf 1.4.3 reference output.
 */
import { SKELETON_DXF_PART_0 } from "./dxfBridge.conformantSkeleton.part0";
import { SKELETON_DXF_PART_1 } from "./dxfBridge.conformantSkeleton.part1";

export const CONFORMANT_BLANK_SKELETON_DXF = `${SKELETON_DXF_PART_0}\n${SKELETON_DXF_PART_1}`;
